import { render, staticRenderFns } from "./TransactionClassification.vue?vue&type=template&id=29b3b190"
import script from "./TransactionClassification.vue?vue&type=script&lang=ts"
export * from "./TransactionClassification.vue?vue&type=script&lang=ts"
import style0 from "./TransactionClassification.vue?vue&type=style&index=0&id=29b3b190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports